import { getBackendUrl } from "@Utils";
import { setLayout } from "../reducers/layout";
import axiosWrapper from "../services/axiosWrapper";

export function fetchLayout() {
  return async (dispatch: any) => {
    const response = await axiosWrapper.get(`${getBackendUrl()}/portal/getLayoutData`);
    if (response.data.status) {
      dispatch(setLayout(response.data.data));
    }
  };
}
